import lodash from 'lodash'
import * as sentry from '../../src/utils/sentry'
import { DS_getData, DS_setData } from '../DS/DS.Data'
import type { I18N_IOverrideDict } from './I18N.overrides'
import type { I18N_ISlugsDict } from './I18N.slugs'
import { IDB_languageOverridesWrite } from '../IDB/IDB.table.languageOverride'
import { IDB_slugs } from '../IDB/IDB.dexie'

export async function I18N_sync(syncLanguage: { dynamic: I18N_ISlugsDict; staticOverrides: I18N_IOverrideDict }) {
    try {
        // If no changes, bail out early
        if (
            syncLanguage == null ||
            (lodash.isEmpty(syncLanguage.dynamic) && lodash.isEmpty(syncLanguage.staticOverrides))
        ) {
            return
        }

        // Update in-memory
        DS_setData('SyncLanguage', ({ languageOverrides, slugs }) => ({
            languageOverrides: { ...languageOverrides, ...syncLanguage.staticOverrides },
            slugs: { ...slugs, ...syncLanguage.dynamic },
        }))

        const { slugs } = DS_getData()

        // Write to disk
        await IDB_slugs().set(slugs)
        await IDB_languageOverridesWrite(syncLanguage.staticOverrides)
    } catch (error) {
        sentry.err(error, {})
    }
}
